var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "range" }, [
    _c("div", { staticClass: "range__track" }, [
      _c("div", { staticClass: "range__thumb" }),
      _vm._v(" "),
      _c("div", {
        staticClass: "range__value",
        style: { background: _vm.color, width: _vm.thumbWidth }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "range__marker",
          style: { background: _vm.color, left: _vm.thumbWidth }
        },
        [
          _vm._v(
            "\n      " +
              _vm._s(_vm.currentValue.title) +
              " " +
              _vm._s(_vm.units) +
              "\n    "
          )
        ]
      ),
      _vm._v(" "),
      _c("div", {
        staticClass: "range__circle",
        style: { background: _vm.color, left: _vm.thumbWidth },
        on: {
          mousedown: function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "left", 37, $event.key, [
                "Left",
                "ArrowLeft"
              ])
            ) {
              return null
            }
            if ("button" in $event && $event.button !== 0) {
              return null
            }
            return _vm.startMoving.apply(null, arguments)
          }
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "range__circles" },
        _vm._l(_vm.data, function(item, i) {
          return _c("div", {
            key: i,
            on: {
              click: function() {
                return _vm.handleCircleClick(item)
              }
            }
          })
        }),
        0
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "range__values" },
      _vm._l(_vm.data, function(item, i) {
        return _c("span", { key: i }, [_vm._v(_vm._s(item.title))])
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }